import { MessageCircle } from "lucide-react";
import { trackConversion } from "@/config/analytics";
import { buildWhatsAppUrl } from "@/lib/phone";
import { useLanguage } from "@/contexts/LanguageContext";

const EN_MESSAGE = "Hello Arabian Al Waha, I'd like to enquire about your services.";
const AR_MESSAGE = "مرحباً العربية الواحة، أود الاستفسار عن خدماتكم.";

const StickyWhatsApp = () => {
  const { language } = useLanguage();
  const isAr = language === "ar";
  const url = buildWhatsAppUrl(isAr ? AR_MESSAGE : EN_MESSAGE);
  const label = isAr ? "تواصل معنا عبر واتساب" : "Chat with us on WhatsApp";
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      onClick={() => trackConversion("whatsapp_click")}
      className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white flex items-center justify-center shadow-elegant ring-4 ring-[#25D366]/25 hover:scale-110 transition-transform"
    >
      <MessageCircle className="w-7 h-7" />
      <span className="sr-only">WhatsApp</span>
    </a>
  );
};

export default StickyWhatsApp;